import { getContentById } from "../../services/content-service";
import React, { useState, useEffect } from "react";
import "../../styles/components/events.css";
import { format } from "date-fns";
import { useAuth0 } from "@auth0/auth0-react";
import { isUserSiteAdmin } from "../../components/shared/utilities";
import AdminRSVPList from "./rsvp-list";
import ContentThumbnail from "../content/content-thumbnail";
import { useNavigate } from "react-router-dom";

export default function EventCard({ event }) {
  const { getAccessTokenSilently, user } = useAuth0();
  const [translatedName, setTranslatedName] = useState(event?.name || "");
  const [translatedDescription, setTranslatedDescription] = useState(event?.description || "");
  const [linkedContent, setLinkedContent] = useState(null);
  const navigate = useNavigate();

  const isAdmin = isUserSiteAdmin(user);

  // fetch linked content if event has linkedContentID
  useEffect(() => {
    async function fetchLinkedContent() {
      if (!event?.linkedContentID) return;
      try {
        const token = await getAccessTokenSilently();
        const { data, error } = await getContentById(token, event.linkedContentID);
        if (error) {
          console.error("Error fetching linked content:", error);
        } else {
          setLinkedContent(data);
        }
      } catch (err) {
        console.error("Auth0 Token Error (content fetch):", err);
      }
    }

    fetchLinkedContent();
  }, [event?.linkedContentID, getAccessTokenSilently]);

  // translation logic
  useEffect(() => {
    const language = localStorage.getItem("language") || "en";

    if (language === "en") {
      setTranslatedName(event?.name || "");
      setTranslatedDescription(event?.description || "");
    } else if (event?.translations) {
      const nameTranslation = event.translations.find(
        (t) => t.language === language && t.fieldName === "Name"
      );
      const descriptionTranslation = event.translations.find(
        (t) => t.language === language && t.fieldName === "Description"
      );

      setTranslatedName(nameTranslation?.contents || event?.name || "");
      setTranslatedDescription(descriptionTranslation?.contents || event?.description || "");
    }
  }, [event]);

  if (!event) {
    return <div>No event data available.</div>;
  }

  return (
    <div className="event-card-glass">
      {isAdmin && (
        <div style={{ alignSelf: "end" }}>
          <button
            className="btn btn1"
            onClick={() => navigate(`/events/${event.id}/edit`, { state: { event } })}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </button>
        </div>
      )}
      <div className="event-card-header">
        <a style={{cursor: "pointer", color: "white", textDecoration: "none", background: "#2f2d2d", padding: "9px", borderRadius: "5px"}} onClick={() => navigate(-1)}>
          <i className="fa-solid fa-arrow-left"></i>
        </a>
        <h2 className="event-title">{translatedName}</h2>
      </div>

      <p className="event-date-large">
        <i className="fa-solid fa-calendar-heart event-icon"></i>{event?.date ? format(new Date(event.date), "PPpp") : "No date selected"}
      </p>

      <p className="event-description-large">
        <i className="fa-solid fa-message-lines event-icon"></i>
        {translatedDescription}
      </p>

      {/* Show linked content thumbnail if available */}
      {linkedContent && (
        <div className="event-linked-content">
          <ContentThumbnail content={linkedContent} />
        </div>
      )}

      {isAdmin && event?.rsvpList?.length > 0 && (
        <div className="event-admin-rsvp-section">
          <AdminRSVPList rsvpList={event.rsvpList} eventID={event.id} eventName={event.name} eventDate={event.date} />
        </div>
      )}

      {!isAdmin && (
        <div className="event-rsvp-noadmin">
          <div className="event-admin-rsvp-section">
            <AdminRSVPList
              rsvpList={event.rsvpList}
              eventID={event.id}
              eventName={event.name}
              eventDate={event.date}
              isReadOnly={true}
              onlyYesNo={true}
              editableContactID={user?.memberId}
            />
          </div>
        </div>
      )}
    </div>
  );
}